/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const demandStatusSchema = z.object({
  archivedAt: z.iso.datetime().nullish(),
  category: z.enum(['OPEN', 'EVALUATING', 'DECIDED', 'WITHDRAWN']),
  color: z.string(),
  id: z.int(),
  isOrganizationDefault: z.boolean(),
  name: z.string(),
  sortOrder: z.int(),
});
